<sa-main [links]="links"></sa-main>
